import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { forkJoin } from "rxjs";
import { Router } from "@angular/router";
import { Card } from "../../../models/card.model";
import { DashboardService } from "../../../services/dashboard.service";
import { NavigationService } from "../../../services/navigation.service";
import { UserService } from "../../../services/user.service";

@Component({
  selector: "app-donor-overview",
  templateUrl: "./donor-overview.component.html",
  styleUrl: "./donor-overview.component.scss",
})
export class DonorOverviewComponent implements OnInit {
  loading = false;
  donors: any[] = [];
  admins: any[] = [];

  selectedCardFilter: string | null = null;
  incomingFilters: Record<string, string[]> = {};
  clearFiltersTrigger = false;

  adminCards: Card[] = [];
  stats = {
    totalApplicants: 0,
    totalApprovedCandidates: 0,
    inReferral: 0,
    underEvaluation: 0,
    awaitingMRB: 0,
  };

  constructor(
    private dashboardService: DashboardService,
    private userService: UserService,
    private navigationService: NavigationService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    const state = this.navigationService.state;

    if (state?.appliedFilters) {
      this.incomingFilters = state.appliedFilters;
    } else {
      this.incomingFilters = {};
    }
    this.loadData();
  }

  loadData() {
    this.loading = true;

    forkJoin({
      donors: this.dashboardService.getAllDonors(),
      admins: this.userService.getHospitalAdminUsers(),
    }).subscribe({
      next: ({ donors, admins }) => {
        this.donors = donors;
        this.loading = false;
        this.cdr.detectChanges();

        this.updateStats(); // Update donor-related stats

        // Sort users by createdAt (newest first)
        this.admins = admins.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );

        this.admins = [...this.admins];
      },
      error: (error) => {
        console.error("Error loading data:", error);
        this.loading = false;
      },
    });
  }

  onActiveCardFilterChange(filterKey: string | null) {
    this.selectedCardFilter = filterKey;
    this.cdr.detectChanges();
  }

  onClearFilters() {
    this.selectedCardFilter = null;

    this.clearFiltersTrigger = true;
    // Reset trigger to allow future toggles
    setTimeout(() => {
      // this.cdr.detectChanges();
      this.clearFiltersTrigger = false;
    });
  }

  updateStats() {
    this.stats.totalApplicants = this.donors.length;

    this.stats.totalApprovedCandidates = this.donors.filter(
      (d) => d.dashboardStatus === "Approved"
    ).length;

    this.stats.inReferral = this.donors.filter(
      (d) => d.dashboardStatus === "In Referral"
    ).length;
    this.stats.underEvaluation = this.donors.filter(
      (d) => d.dashboardStatus === "Under Evaluation"
    ).length;
    this.stats.awaitingMRB = this.donors.filter(
      (d) => d.dashboardStatus === "Awaiting MRB"
    ).length;

    this.adminCards = [
      {
        id: "totalApplicants",
        title: "Total Donors & Donor Candidates",
        filterId: "",
        icon: "bi-people",
        value: this.stats.totalApplicants,
      },
      {
        id: "totalApprovedCandidates",
        title: "Total Donors",
        filterId: "",
        icon: "bi-person-check",
        value: this.stats.totalApprovedCandidates,
      },
      {
        id: "inReferral",
        title: "Donor Candidates In Referral",
        filterId: "In Referral",
        icon: "bi-clipboard",
        value: this.stats.inReferral,
      },
      {
        id: "underEvaluation",
        title: "Donor Candidates Under Evaluation",
        filterId: "Under Evaluation",
        icon: "bi-arrow-repeat",
        value: this.stats.underEvaluation,
      },
      {
        id: "awaitingMRB",
        title: "Donor Candidates Awaiting Review",
        filterId: "Awaiting MRB",
        icon: "bi-clock",
        value: this.stats.awaitingMRB,
      },
    ];

    this.cdr.detectChanges();
  }
}
